// extracted by mini-css-extract-plugin
module.exports = {"facet-list":"SearchFacets_facet-list__3qvyi","facet-list-item":"SearchFacets_facet-list-item__MFkA1","search-fade-in":"SearchFacets_search-fade-in__k6SkJ"};